import React, {useEffect, useState} from 'react';
import {useActions} from "../../hook/useActions";
import styles from "./Gcal.module.scss";
import {useTypedSelector} from "../../hook/useTypedSelector";
import {DayPicker} from "react-day-picker";
import "react-day-picker/style.css";
import "./style.css"
import SearchableDropDown from "../dropdownSearchable";
import dropdownCommon from "../dropdown/DropdownCommon.module.scss"
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {languages} from "../../language/localesList";
import {convertFromWinter} from "../../pages/yearcalendar/dstToLtConverter";
import {enUS, ru, uk} from "date-fns/locale";
import {getLocalCitiesByCountry} from "../../constants/country-list";
import {ekadasi} from "../../constants/ekadasi-list";
import {getBreakFastTime, removeLastAdjacentDuplicate} from "../../pages/yearcalendar";

import MainPageEditor from "../TextEditor";

const locales = {
    en: enUS,
    ru: ru,
    ua: uk,
};

const overflowEvents = [
    {
        date: new Date(2026, 4, 26),
        country: "Ukraine",
        offset: 1,
    },
    // Add Ekadashi dates to move them to other day
];
const getOverflowEventData = (date: Date) => {
    const event = overflowEvents.find(e => e.date.getTime() === date.getTime());
    return event ? event : null;
}


const overflowBreakfast = [
    {
        date: new Date(2026, 4, 27),
        country: "Ukraine",
        transferTo: new Date(2026, 4, 28),
    },
    // Add Breakfast dates to move them to other day
];
const getOverflowBreakfastData = (tDate: Date) => {
    const breakfast = overflowBreakfast.find(e => e.transferTo.getTime() === tDate.getTime() || e.date.getTime() === tDate.getTime());
    return breakfast ? breakfast : null;
}

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const getDayDiff = (a: Date, b: Date) => {
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / MS_PER_DAY);
}


const redefineBreakfast = [
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Cherkasy",
        exitTime: "вихід 04:54 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Chernihiv",
        exitTime: "вихід 04:47 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Chernivtsi",
        exitTime: "вихід 05:23 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Dnipropetrovs'k",
        exitTime: "вихід 04:46 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Donets'k",
        exitTime: "вихід 04:37 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Kharkiv",
        exitTime: "вихід 04:35 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Kherson",
        exitTime: "вихід 05:03 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Kirovohrad",
        exitTime: "вихід 04:56 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "L'viv",
        exitTime: "вихід 05:24 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Luhans'k",
        exitTime: "вихід 04:41 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Luts'k",
        exitTime: "вихід 05:14 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Mykolayiv",
        exitTime: "вихід 05:04 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Odesa",
        exitTime: "вихід 05:11 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Poltava",
        exitTime: "вихід 04:43 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Rivne",
        exitTime: "вихід 05:11 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Sumy",
        exitTime: "вихід 04:45 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Ternopil'",
        exitTime: "вихід 05:19 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Vinnytsya",
        exitTime: "вихід 05:09 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Zaporizhzhya",
        exitTime: "вихід 04:47 до 05:29",
    },
    {
        date: new Date(2026, 4, 28),
        country: "Ukraine",
        city: "Zhytomyr",
        exitTime: "вихід 05:03 до 05:29",
    },
    // Add Breakfast exit time to set them manually
];
const getRedefineBreakfastData = (tDate: Date, country: string, city: string) => {
    const breakfast = redefineBreakfast.find(e => e.date.getTime() === tDate.getTime() && e.country === country && e.city === city);
    return breakfast ? breakfast : null;
}


function GaurabdaCalendar() {
    const {
        GetCalendar,
        GetCityByCountry,
        GetCountry,
        LoadCalendarFromLoacalStorage,
        LogOut,
        GetMainPageTextAsync,
        UpdateMainPageTextAsync
    } = useActions();
    const [fullMoon, setFullMoon] = useState<boolean>(false);
    const [calendarLoaded, setCalendarLoaded] = useState<boolean>(false);
    const [localStorageLoaded, setLocalStorageLoaded] = useState<boolean>(false);
    const [moon, setMoon] = useState<number>(0);
    const [currentDay, setCurrentDay] = useState<number>(0);
    const [selected, setSelected] = useState<Date>();
    const [month, setMonth] = useState<Date>();
    const [moonRise, setMoonRise] = useState<any>();
    const [sunRise, setSunRise] = useState<any>();
    const [nextEkadashi, setNextEkadashi] = useState<string>("");
    const [nextEkadashiDate, setNextEkadashiDate] = useState<string>("");
    const [nextEkadashiFastingEnd, setNextEkadashiFastingEnd] = useState<string>("");
    const [selectedDayText, setSelectedDayText] = useState<string>("");
    const [ekadashiDays, setEkadashiDays] = useState<Date[]>([new Date(2025, 2, 5)]);

    const [country, setCountry] = useState<string>("Select country");
    const [city, setCity] = useState<string>("Select city");

    const SunCalc = require('suncalc');
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const currentLocale = locales[i18n.language as keyof typeof locales] || enUS;

    const {calendar, allCities, allCountries} = useTypedSelector((state) => state.calendar);
    const {isAuth, user} = useTypedSelector((state) => state.user);
    const {mainPageText} = useTypedSelector((state) => state.pagesConfigReducer);

    useEffect(() => {
        setCalendarLoaded(true);
        GetMainPageTextAsync();
        GetCountry();
        document.title = t("Calendar.Page title");
        const savedCountry = localStorage.getItem("country");
        const savedCity = localStorage.getItem("city");
        if (savedCountry != null && savedCity != null) {
            setCountry(savedCountry);
            setCity(savedCity);
            GetCityByCountry(savedCountry);
            const localCalendar = localStorage.getItem(savedCity + " (" + savedCountry + ")");
            if (localCalendar !== null) {
                LoadCalendarFromLoacalStorage(JSON.parse(localCalendar));
            }
        }
        setNextEkadashi("");
        setNextEkadashiFastingEnd("");
        setLocalStorageLoaded(true);
    }, []);

    useEffect(() => {
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        date.setDate(1);
        getCalendar(date, getPeriod(date, 3));
    }, [calendarLoaded]);

    useEffect(() => {
        if (!calendarLoaded || month === undefined)
            return;
        let date: Date = new Date(month);
        let isExists = isCalendarMonthesExist(new Date(month));
        if (!isExists.behind) {
            date.setMonth(date.getMonth() - 1);
            getCalendar(date, getPeriod(date, 1));
        }
        if (!isExists.ahead) {
            date.setMonth(date.getMonth() + 1);
            getCalendar(date, getPeriod(date, 1));
        }
        // if(!isExists.now){
        //     getCalendar(date, getPeriod(date, 1));
        // }
    }, [month]);

    function getCalendar(date: Date, period: number) {
        let data;
        if ((country !== "Select country" && city !== "Select city")) {
            const localCity = getLocalCitiesByCountry(country).find(c => c.name === city);
            if (localCity !== undefined) {
                data = {
                    city: city,
                    country: country,
                    longitude: localCity.longitude,
                    latitude: localCity.latitude,
                    // tzname: localCity.timezone,
                    period: period,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: 1
                }
            } else {
                data = {
                    city: city,
                    country: country,
                    period: period,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: 1
                }
            }
        } else {
            data = {
                city: "Rivne",
                country: "Ukraine",
                period: period,
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: 1
            }
        }
        GetCalendar(data);
    }

    function isCalendarMonthesExist(date: Date) {
        let data = {
            behind: false,
            now: false,
            ahead: false,
        }

        data.now = calendar.days.findIndex((day: any) => day.date.month === date.getMonth() + 1 && day.date.year === date.getFullYear()) !== -1;
        date.setMonth(date.getMonth() - 1);
        data.behind = calendar.days.findIndex((day: any) => day.date.month === date.getMonth() + 1 && day.date.year === date.getFullYear()) !== -1;
        date.setMonth(date.getMonth() + 2);
        data.ahead = calendar.days.findIndex((day: any) => day.date.month === date.getMonth() + 1 && day.date.year === date.getFullYear()) !== -1;
        return data;
    }

    function getDaysInMonth(date: Date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    function getPeriod(startDate: Date, monthCount: number) {
        let period = 0;
        let date = new Date(startDate);
        while (monthCount > 0) {
            period += getDaysInMonth(date);
            monthCount -= 1;
            date.setMonth(date.getMonth() + 1);
            // console.log(new Date(date.getFullYear(), date.getMonth(), 0), period);
        }
        return period;
    }

    useEffect(() => {
        if (calendar == null) {
            return;
        }
        if (!localStorageLoaded) {
            return;
        }

        let date: Date;
        if (selected !== undefined) {
            date = selected;
        } else {
            date = new Date();
        }
        setCurrentDay(calendar.days.findIndex((day: any) => day.date.day === date.getDate() &&
            day.date.month === date.getMonth() + 1 &&
            day.date.year === date.getFullYear()));
    }, [calendar, selected, localStorageLoaded])

    useEffect(() => {
        if (calendar == null || !calendar.days[currentDay]) {
            return;
        }

        let tithi = calendar.days[currentDay].astrodata.tithi;
        if (tithi > 14) {
            tithi -= 15;
            setFullMoon(true);
        } else {
            setFullMoon(false);
        }
        setMoon(tithi);

        const date = new Date(`${calendar.days[currentDay].date.year}-${calendar.days[currentDay].date.month}-${calendar.days[currentDay].date.day}`);
        setMoonRise(SunCalc.getMoonTimes(date, calendar.location.latitude, calendar.location.longitude));
        setSunRise(SunCalc.getTimes(date, calendar.location.latitude, calendar.location.longitude));

        if (calendarLoaded && calendar.days) {
            // const ekadasiList = removeLastAdjacentDuplicate(calendar.days.slice(currentDay, currentDay + 20)).filter((d: any) => d.ekadashiName !== "");
            // setNextEkadashiFastingEnd(getBreakFastTime(ekadasiList[0]));


            const breakfastTransfer = getOverflowBreakfastData(new Date(calendar.days[currentDay].date.year, calendar.days[currentDay].date.month - 1, calendar.days[currentDay].date.day));
            const breakfastTransferOffset = (breakfastTransfer && (breakfastTransfer.country === (country === "Select country" ? "Ukraine" : country))) ? getDayDiff(breakfastTransfer.date, breakfastTransfer.transferTo) : null;
            const curDays = breakfastTransferOffset ? calendar.days.slice(currentDay - breakfastTransferOffset - 1, currentDay - breakfastTransferOffset + 1) : calendar.days.slice(currentDay - 1, currentDay + 1);
            if (curDays.length == 2 && curDays[0].ekadashiName !== "" && curDays[1].events && curDays[1].events.length > 0 && curDays[1].events[0].text.includes("Break fast"))
                setNextEkadashiFastingEnd(getBreakFastTime(curDays[1]));
            else
                setNextEkadashiFastingEnd("");

            const redefineData = getRedefineBreakfastData(
                new Date(calendar.days[currentDay].date.year, calendar.days[currentDay].date.month - 1, calendar.days[currentDay].date.day),
                (country === "Select country" ? "Ukraine" : country),
                (city === "Select city" ? "Rivne" : city)
            );
            if (redefineData) setNextEkadashiFastingEnd(redefineData.exitTime);

            setNextEkadashi(calendar.days.slice(currentDay).find((d: any) => d.ekadashiName !== "").ekadashiName.replace(" Ekadasi", ""));
            const NED = calendar.days.slice(currentDay).find((d: any) => d.ekadashiName !== "").date;
            setNextEkadashiDate(NED.day.toString().padStart(2, '0') + "." + NED.month.toString().padStart(2, '0'));
            let days: Date[] = [];
            removeLastAdjacentDuplicate(calendar.days).forEach((d: any) => {
                if (d.ekadashiName !== "") {
                    days.push(new Date(d.date.year, d.date.month - 1, d.date.day));
                }
            });


            // Check for overflow events on the current date and adjust the dates accordingly
            const updatedDates = days.map(date => {
                const overflow = getOverflowEventData(date);

                if (!overflow || overflow.country !== (country === "Select country" ? "Ukraine" : country)) {
                    return date;
                }

                const newDate = new Date(date);
                newDate.setDate(newDate.getDate() + overflow.offset);

                return newDate;
            });

            setEkadashiDays(updatedDates);
        }
    }, [calendar, currentDay]);

    function onCountrySelected(selectedCountry: string) {
        setCountry(selectedCountry);
        GetCityByCountry(selectedCountry);
    }

    function onCitySelected(selectedCity: string) {
        setCity(selectedCity);
        localStorage.setItem("country", country);
        localStorage.setItem("city", selectedCity);
        navigate(0);
    }

    function onPrintClickHandler() {
        if (!isAuth) {
            navigate("/login");
            return;
        }
        if (month) {
            navigate("/full-year-calendar?country=" + country + "&city=" + city + "&year=" + month.getFullYear());
        } else {
            navigate("/full-year-calendar?country=" + country + "&city=" + city + "&year=" + (selected ? selected.getFullYear() : new Date().getFullYear()));
        }
    }

    function onLanguageSelected(selectedLanguage: string) {
        let lng = Object.entries(languages).find(([_, value]) => value === selectedLanguage)?.[0];
        if (lng)
            i18n.changeLanguage(lng);
    }

    const modifiers = {
        highlighted: ekadashiDays,
    };
    const modifiersClassNames = {
        highlighted: "highlighted-day",
    };

    return (
        calendar && (calendarLoaded) && nextEkadashi !== "" && calendar.count < 100 &&
        <>
            <div style={{marginLeft: "20px", width: "638px", display: "flex", justifyContent: "center"}}>
                <div className={styles.gaurabdaCalendarContainer}>
                    <img className={styles.gaurabdaCalendar}
                         src={'/images/calendar_v2/moons/' + i18n.language + '/bg3.png'}
                         alt="gaurabda-calendar"></img>
                    <img className={styles.gaurabdaCalendarLogo} src={'/images/calendar_v2/logo.svg'}
                         alt="gaurabda-calendar"></img>
                    <img className={styles.gaurabdaCalendar}
                         src={`/images/calendar_v2/moons/${fullMoon ? "fullMoon" : "newMoon"}_v2.png`}
                         alt="gaurabda-calendar"></img>
                    <img className={styles.gaurabdaCalendar}
                         src={`/images/calendar_v2/moons/${moon + 1}.png`}
                         alt="gaurabda-calendar"></img>
                    <div className={styles.DayCalendar}>
                        <DayPicker
                            mode="single"
                            selected={selected}
                            onSelect={(data) => {
                                setSelected(data);
                                if (data) {
                                    setSelectedDayText(data.getDate().toString().padStart(2, '0') + "." + (data.getMonth() + 1).toString().padStart(2, '0'));
                                } else {
                                    setSelectedDayText("");
                                }
                            }}
                            weekStartsOn={1}
                            showOutsideDays={true}
                            onMonthChange={setMonth}
                            locale={currentLocale}
                            modifiers={modifiers}
                            modifiersClassNames={modifiersClassNames}
                        />
                    </div>
                    <div
                        className={`${styles.aboutDay}`}>
                        <span>{selectedDayText === "" ? t("Calendar.Today") : selectedDayText}: </span><span>{t("Moons." + [fullMoon ? 15 + moon : moon])}</span>{nextEkadashiFastingEnd !== "" &&
                        <span> {t("Calendar.Exit")} {nextEkadashiFastingEnd}</span>}</div>
                    {/*<div className={styles.calendarLabel}>*/}
                    {/*    {t("Calendar.Calendar")}*/}
                    <img
                        className={styles.print}
                        src={"/images/calendar/print_enabled.png"}
                        alt={"print"}
                        onClick={onPrintClickHandler}
                        onMouseOver={e => (e.currentTarget.src = "/images/calendar/print_disabled.png")}
                        onMouseOut={e => (e.currentTarget.src = "/images/calendar/print_enabled.png")}
                    />
                    {/*</div>*/}
                    {/*<button className={styles.reliefButton + " " + styles.L}*/}
                    {/*        onClick={() => {*/}
                    {/*            window.open(process.env.REACT_APP_BASE_URL + "/locales/" + i18n.language + "/PDF/Instruction.pdf", "_blank");*/}
                    {/*        }}*/}
                    {/*>{t("Calendar.Instructions")}</button>*/}
                    {/*<button className={styles.reliefButton + " " + styles.R}*/}
                    {/*        onClick={() => navigate("/ekadashi-list")}>{t("Calendar.REPORT")}</button>*/}

                    {/*<div className={styles.calendarNav}>*/}
                    {/*    <div className={styles.sideColumn}>*/}
                    <div className={styles.dropdowns}>
                        <SearchableDropDown options={allCountries} defaultValue={country}
                                            onChange={onCountrySelected} styles={dropdownCommon} width={120}/>
                        <SearchableDropDown options={allCities} defaultValue={city}
                                            onChange={onCitySelected} styles={dropdownCommon} width={110}
                                            translatePrefix={"Cities"}/>
                        <SearchableDropDown options={Object.values(languages)} defaultValue={languages[i18n.language]}
                                            onChange={onLanguageSelected} styles={dropdownCommon} width={120}/>
                    </div>
                    {moonRise &&
                        <>
                            <div className={styles.riseAndSet}>
                                <div className={styles.riseAndSetYellow}>
                                    <p>{t("Calendar.SunRise")}</p>
                                    <div>
                                        <div>
                                            {calendar.days[currentDay] ? convertFromWinter(
                                                {
                                                    time: calendar.days[currentDay].astrodata.sun.rise,
                                                    day: calendar.days[currentDay].date.day,
                                                    month: calendar.days[currentDay].date.month,
                                                    year: calendar.days[currentDay].date.year
                                                }).time : "--:--"}
                                        </div>
                                        <div>
                                            {calendar.days[currentDay] ? convertFromWinter(
                                                {
                                                    time: calendar.days[currentDay].astrodata.sun.set,
                                                    day: calendar.days[currentDay].date.day,
                                                    month: calendar.days[currentDay].date.month,
                                                    year: calendar.days[currentDay].date.year
                                                }).time : "--:--"}
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.riseAndSetBlue}>
                                    <p>{t("Calendar.MoonRise")}</p>
                                    <div>
                                        <div>
                                            {moonRise.rise && calendar.days[currentDay] ? moonRise.rise.toTimeString().slice(0, 5) : "-"}
                                        </div>
                                        <div>
                                            {moonRise.set && calendar.days[currentDay] ? moonRise.set.toTimeString().slice(0, 5) : "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {/*    </div>*/}
                    {/*    <div className={styles.sideColumn}>*/}
                    {/*        <div className={styles.sideBtnTitle}>{t("Calendar.History and blessings")}</div>*/}
                    {/*        {calendar.days[currentDay] ?*/}
                    {/*        <button className={styles.sideBtn + " " + styles.btnYellow}*/}
                    {/*                onClick={() => {*/}
                    {/*                    window.open(process.env.REACT_APP_BASE_URL + "/locales/" + i18n.language + "/PDF/Ekadashi/014-" +*/}
                    {/*                        (ekadasi.findIndex((x) => x === nextEkadashi) + 1 < 10 ? "0" : "") + (ekadasi.findIndex((x) => x === nextEkadashi) + 1)*/}
                    {/*                        + ".pdf", "_blank");*/}
                    {/*                }}*/}
                    {/*        >{t("Ekadasi." + nextEkadashi)}</button>*/}
                    {/*        :*/}
                    {/*            <button className={styles.sideBtn + " " + styles.btnYellow}>Loading...</button>}*/}
                    {/*        <div className={styles.sideBtnTitle}>{t("Calendar.Astrological calendar")}</div>*/}
                    {/*        <button onClick={() => {*/}
                    {/*            navigate(`/astrological-diary?date=${calendar.days[currentDay].date.year}-${(calendar.days[currentDay].date.month < 10 ? "0" : "") + calendar.days[currentDay].date.month}-${(calendar.days[currentDay].date.day < 10 ? "0" : "") + calendar.days[currentDay].date.day}`);*/}
                    {/*        }}*/}
                    {/*                className={styles.sideBtn + " " + styles.btnBlue}>*/}
                    {/*            {calendar.days[currentDay] ? calendar.days[currentDay].date.day.toString().padStart(2, '0') : "--"}.*/}
                    {/*            {calendar.days[currentDay] ? calendar.days[currentDay].date.month.toString().padStart(2, '0') : "--"}*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {nextEkadashiDate !== "" &&
                        <div className={styles.nextEkadashi}>
                            <div>{t("Calendar.NextFasting")}</div>
                            <div className={styles.rectangle + " " + styles.clickable}
                                 onClick={() => {
                                     window.open(process.env.REACT_APP_BASE_URL + "/locales/" + i18n.language + "/PDF/Ekadashi/014-" +
                                         (ekadasi.findIndex((x) => x === nextEkadashi) + 1 < 10 ? "0" : "") + (ekadasi.findIndex((x) => x === nextEkadashi) + 1)
                                         + ".pdf", "_blank");
                                 }}
                            >{t("Ekadasi." + nextEkadashi)}</div>
                            <div className={styles.rectangle}>{nextEkadashiDate + "."}</div>
                        </div>
                    }
                    <div className={styles.bottomMenu}>
                        <div onClick={() => {
                            window.open(process.env.REACT_APP_BASE_URL + "/locales/" + i18n.language + "/PDF/Instruction.pdf", "_blank");
                        }}>{t("NavPanel.Instructions")}</div>
                        <div onClick={() => {
                            navigate("/philosophy")
                        }}>{t("NavPanel.Philosophy")}</div>
                        <div onClick={() => {
                            navigate(`/astrological-diary?date=${calendar.days[currentDay].date.year}-${(calendar.days[currentDay].date.month < 10 ? "0" : "") + calendar.days[currentDay].date.month}-${(calendar.days[currentDay].date.day < 10 ? "0" : "") + calendar.days[currentDay].date.day}`);
                        }}>{t("NavPanel.AstroDiaryShort")}</div>
                        <div onClick={() => navigate("/information")}>{t("NavPanel.Information")}</div>
                        {!isAuth ?
                            <div onClick={() => navigate("/login")}>{t("NavPanel.Login")}</div>
                            :
                            <div onClick={() => {
                                LogOut();
                                navigate("/");
                            }}>{t("Profile.Logout")}</div>
                        }
                    </div>
                </div>
            </div>

            <MainPageEditor/>

        </>
    );
}

export default GaurabdaCalendar;

